import { render, staticRenderFns } from "./widgetBadget.vue?vue&type=template&id=0a44ab31&scoped=true"
import script from "./widgetBadget.vue?vue&type=script&lang=js"
export * from "./widgetBadget.vue?vue&type=script&lang=js"
import style0 from "./widgetBadget.vue?vue&type=style&index=0&id=0a44ab31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44ab31",
  null
  
)

export default component.exports